export default __webpack_public_path__ + "static/media/Punto_06_Chiesa_e_Convento_dei_Domenicani_ITA_Def.7f010a41.aac";